import { render, staticRenderFns } from "./FileShareRole.vue?vue&type=template&id=faffd938&scoped=true&"
import script from "./FileShareRole.vue?vue&type=script&lang=js&"
export * from "./FileShareRole.vue?vue&type=script&lang=js&"
import style0 from "./FileShareRole.vue?vue&type=style&index=0&id=faffd938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faffd938",
  null
  
)

export default component.exports